<template>
	<LoginForm @login-success="onLoginSuccess" />
</template>

<script>
export default {
	name: "AuthLogin",
	components: {
		LoginForm: () => import("../../components/LoginForm")
	},
	methods: {
		onLoginSuccess() {
			this.$router.replace({ name: "AuthIndex" }).catch()
		}
	}
}
</script>
